// extracted by mini-css-extract-plugin
export default {"pageWrap":"tc-z","fullWidth":"uc-z","heading":"vc-z","fullBleed":"wc-z","hidden":"xc-z"};